import { useEffect } from "react";
import { usePrevious } from "@/shared/hooks";
import type { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_PAGINATION } from "../utils/default-pagination";

export const usePagination = (
  pagination?: TablePaginationConfig,
  onTotalPagesChange?: (total?: number) => void,
): TablePaginationConfig => {
  const prevPagination = usePrevious<TablePaginationConfig | undefined>(pagination);

  useEffect(() => {
    if (!pagination || !prevPagination) {
      return;
    }

    if (pagination.total !== prevPagination.total) {
      onTotalPagesChange?.(pagination.total);
    }
  }, [pagination]);

  return { ...DEFAULT_PAGINATION, ...pagination };
};
